/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrderInfo200Response
 */
export interface UpdateOrderInfo200Response {
    /**
     * 注文番号
     * @type {string}
     * @memberof UpdateOrderInfo200Response
     */
    orderNo: string;
}

/**
 * Check if a given object implements the UpdateOrderInfo200Response interface.
 */
export function instanceOfUpdateOrderInfo200Response(value: object): value is UpdateOrderInfo200Response {
    if (!('orderNo' in value) || value['orderNo'] === undefined) return false;
    return true;
}

export function UpdateOrderInfo200ResponseFromJSON(json: any): UpdateOrderInfo200Response {
    return UpdateOrderInfo200ResponseFromJSONTyped(json, false);
}

export function UpdateOrderInfo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrderInfo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'orderNo': json['order_no'],
    };
}

export function UpdateOrderInfo200ResponseToJSON(json: any): UpdateOrderInfo200Response {
    return UpdateOrderInfo200ResponseToJSONTyped(json, false);
}

export function UpdateOrderInfo200ResponseToJSONTyped(value?: UpdateOrderInfo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'order_no': value['orderNo'],
    };
}

